import { render, staticRenderFns } from "./DatatableResolution.vue?vue&type=template&id=9a8795ba&"
import script from "./DatatableResolution.vue?vue&type=script&lang=js&"
export * from "./DatatableResolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports